export const DISCLAIMER_CLASSNAME = 'c-hero__disclaimer';
export const DISCLAIMER_TEXT_CLASSNAME = 'c-hero__disclaimer-text';
export const VIDEO_TITLE_MODIFIER = 'video-title';
export const DISCLAIMER_TEXT_SCROLL_MODIFIER = 'scrolling';
